import axios from 'axios';

const state = {
    blast_list: "",
};

const getters = {

};

const actions = {
    blast_list_all({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.get('blast-lists', { params: data })
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_stop({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('blast-lists/stop', data)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_resend_pending({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('blast-lists/resend/pending', data)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_resend_failed({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('blast-lists/resend/failed', data)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_create({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('blast-lists', data)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_one({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.get('blast-lists/' + data.id)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_update({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.put('blast-lists/' + data.id, data)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_delete({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.delete('blast-lists/' + data.id)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_export({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('blast-lists/export', data)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_delete_all({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('blast-lists/delete/all', data)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_delete_inactive({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('blast-lists/delete/inactive', data)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    blast_list_delete_draft({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('blast-lists/delete/draft', data)
            .then(response => {
                commit("PUSH_MESSAGE", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
}

const mutations = {
    PUSH_MESSAGE(state, data){
        state.blast_list = data
    },
};

export default {
  state,
  getters,
  actions,
  mutations
};
